/* src/app/components/sidebar/sidebar.component.scss */
/*# sourceMappingURL=sidebar.component.css.map */
